module.exports = __webpack_public_path__ + "img/ico-double-arrow-up-brown.be6d5175.svg";